var map = {
	"./image_sonaeru": 49,
	"./image_sonaeru.jpeg": 82,
	"./image_sonaeru.png": 49,
	"./no_image": 58,
	"./no_image.png": 58,
	"./sakoju_image": 59,
	"./sakoju_image.png": 59,
	"./senior_home_image": 60,
	"./senior_home_image.png": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;